import { Site } from "./sites.model";

export class Commercial{
    id: number;
    name: string;
    address: string;
    email: string;
    phone: string;
    sites: Site[];

    constructor() { }
}


export class CommercialForm{
    id: number;
    name: string;
    address: string;
    email: string;
    phone: string;
    sites: number[];

    constructor() { }
}